import { render, staticRenderFns } from "./AdminRoleAdd.form.vue?vue&type=template&id=3576c26b&"
import script from "./AdminRoleAdd.form.vue?vue&type=script&lang=js&"
export * from "./AdminRoleAdd.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports